import "./PromoStep.scss";
import ButtonSubmit from "../ButtonSubmit";
import { simplyClick } from "../../helpers";
import girlPromo from "../../images/girl-promo.jpg";

function PromoStep({ nextStep }) {
  return (
    <>
      <div className="promo__wrapper">
        <div className="user__form-top">
          <h3>Your dream match awaits</h3>
        </div>
        <div className="user__form-content">
          <div className="user__form-image">
            <img src={girlPromo} alt="girl" />
          </div>
          <h4>The real deal!</h4>
          <div className="text__wrapper">
            <p>
              Only safe, private, and convenient connections built on mutual
              respect. Ready for next-level matching?
            </p>
          </div>

          <ButtonSubmit
            onClick={() => {
              simplyClick("cl_lnd_lt2_match_me");
              nextStep();
            }}
            className={"button__global button__promo"}
            text={"Find me a match"}
            dataAttr={"cookies"}
          />
          <div className="progress__dots">
            <span className="active"></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </>
  );
}

export default PromoStep;
